<template>
    <div v-if="Value != '0001-01-01T00:00:00'">
        {{ new Date(Value).toLocaleString() }}
    </div>
</template>

<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class GenericTableDateCell extends Vue {
    /** Valeur */
    @Prop({ default: () => '0001-01-01T00:00:00' })
    public Value!: string;
}
</script>
<style scoped>

</style>